
import { Component, OnInit, OnDestroy, NgZone, inject } from '@angular/core';
import { Location, AsyncPipe } from '@angular/common';
import { Router, Event, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { GalleryService } from '../../services/gallery.service';
import { HeadService } from '../../services/head.service';
import { TitleService } from '../../services/title.service';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import config from '../../page-config';
import { BreadCrumbComponent } from '../breadcrumb/breadcrumb.component';
import { PaginationComponent } from '../pagination/pagination.component';
import { ThumbnailComponent } from '../thumbnail/thumbnail.component';

@Component({
    selector: 'app-gallery',
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.scss'],
    imports: [BreadCrumbComponent, PaginationComponent, ThumbnailComponent, AsyncPipe]
})
export class GalleryComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private location = inject(Location);
  private route = inject(ActivatedRoute);
  private zone = inject(NgZone);
  private headService = inject(HeadService);
  private titleService = inject(TitleService);
  private breadcrumbService = inject(BreadcrumbService);
  galleryService = inject(GalleryService);


  subscription: Subscription;
  routeSubscription: Subscription;
  gallerySubscription: Subscription;
  currentPage = { code: '', title: '', description: ''};
  pagination = {
    page: 1,
    pageSize: 10,
    numberOfPages: 1,
    totalCount: 0,
    collectionUrl: '',
    pages: [],
    previousPage: 1,
    nextPage: 2,
  };

  ngOnInit() {
    this.subscription = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this._cleanState();
        this.render();
      }
    });
    this.render();
  }

  ngOnDestroy() {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
    this._cleanState();
  }

  _cleanState() {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
    if (this.gallerySubscription) {
      this.gallerySubscription.unsubscribe();
    }
  }

  _preparePagination(collectionUrl: string, page = 1, totalCount = 0, pageSize = 10) {
    this.pagination.page = page;
    this.pagination.pageSize = pageSize;
    this.pagination.totalCount = totalCount;
    this.pagination.numberOfPages = Math.ceil(this.pagination.totalCount / this.pagination.pageSize);
    this.pagination.collectionUrl = collectionUrl;
    this.pagination.pages = [];
    for(let i = 1; i <= this.pagination.numberOfPages; i++) {
      this.pagination.pages.push(i);
    }
    if(this.pagination.page > 1) {
      this.pagination.previousPage = this.pagination.pages[this.pagination.page - 2];
    }
    if(this.pagination.page < this.pagination.numberOfPages) {
      this.pagination.nextPage = this.pagination.pages[this.pagination.page];
    }
  }

  render(): void {
    const initialParams = this.route.snapshot.queryParams;
    let { page = 1 } = initialParams;

    this.routeSubscription = this.route.params.subscribe(({ collection, type }) => {
      page = Number(page);
      const collectionUrl = `/collection/${collection}/${type}`;
      this.currentPage = config.pages[collectionUrl];
      if(!this.currentPage) {
        this.router.navigate(['/404']);
        return;
      }
      this.titleService.set(this.currentPage.title);
      this.headService.setMetaDescription(`${this.currentPage.description} - Irish Celtic Jewellery`);
      this.breadcrumbService.set(this.currentPage.title);
      this.getGallery(collectionUrl, page);
    });
  }

  getGallery(collectionUrl: string, page: number): void {
    this.gallerySubscription = this.galleryService.fetch(this.currentPage.code, page).subscribe((data) => {
      const { totalCount, pageSize } = data.metadata;
      this._preparePagination(collectionUrl, page, totalCount, pageSize);
    });
  }

}
